export const bindAll = (ctx, arr) => {
  arr.forEach((fn) => (ctx[fn] = ctx[fn].bind(ctx)))
}

export const preloadMedia = (element) => {
  const allMediaElements = Array.from(element.querySelectorAll('img, video'))

  return Promise.all(
    allMediaElements.map((media) => {
      return new Promise((resolve, reject) => {
        const onLoad = () => {
          cleanup()
          resolve(media)
        }

        const onError = () => {
          cleanup()
          reject(new Error(`Failed to load ${media.src}`))
        }

        const removeLazyLoading = (media) => {
          media.removeAttribute('loading')
          media.removeAttribute('data-lazy-image')
        }

        const cleanup = () => {
          media.removeEventListener('load', onLoad)
          media.removeEventListener('error', onError)
        }

        if (media.tagName === 'IMG') {
          removeLazyLoading(media)
          if (media.complete) {
            resolve(media)
          } else {
            media
              .decode()
              .then(() => {
                resolve(media)
              })
              .catch(() => onError)
          }
        } else if (media.tagName === 'VIDEO') {
          if (media.readyState >= 1) {
            // Metadata has been loaded
            resolve(media)
          } else {
            media.addEventListener('loadedmetadata', onLoad)
            media.addEventListener('error', onError)
          }
        } else {
          reject(new Error('Unsupported media type'))
        }
      })
    })
  )
}

export const lerp = (current, destination, factor) =>
  current + (destination - current) * factor

export const clamp = (value, min, max) => Math.min(max, Math.max(min, value))

export const pasteToClipboard = async (text) => {
  try {
    await navigator.clipboard.writeText(text)
    return true
  } catch {
    return new Error('impossible to past to clipbaord')
  }
}
